import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  pairedDevices: {},
  pairing: false,
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.DEVICES_LOADED: {
      const { devices } = action.payload;

      result = _.assign({}, state, {
        pairedDevices: _.keyBy(devices, 'id'),
      });
      break;
    }

    case actionTypes.DEVICE_PAIR_STARTED: {
      result = _.assign({}, state, {
        pairing: true,
      });
      break;
    }

    case actionTypes.DEVICE_PAIR_FAILED: {
      result = _.assign({}, state, {
        pairing: false,
      });
      break;
    }

    case actionTypes.DEVICE_PAIR_SUCCEEDED: {
      const { device } = action.payload;
      result = _.assign({}, state, {
        pairing: false,
      });
      result.pairedDevices[device.id] = device;
      break;
    }

    case actionTypes.DEVICE_UNPAIRED: {
      const { deviceId } = action.payload;
      result = _.assign({}, state);
      delete result.pairedDevices[deviceId];
      break;
    }

    default: {
      result = _.assign({}, state);
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/devices.js